import CookieConsent from 'react-cookie-consent';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserCircle, faRss, faUndo, faQuestionCircle, faChartBar, faCalendarPlus } from '@fortawesome/free-solid-svg-icons';
import './Footer.css';
import { useEffect, useState } from 'react';
import api from '../../_helpers/Request/api';

const Footer = () => {
    const [version, setVersion] = useState('');

    // useEffect(async () => {
    //     const { data } = await api.get('version/get');
    //     if (data) setVersion(data);
    // }, []);

    return (
        <>
            <footer className="footerPrimary">
                <footer className="footer">
                    <div id="info">
                        <div className="container">
                            <div className="row">
                                <div className="col-12 col-xl-4">
                                    <div style={{ fontSize: '22px', fontWeight: 'bold' }} className="widgettitle">
                                        Informacja Urzędu:{' '}
                                        <a href="tel:+48717777777">
                                            tel.<u> +48 71 777 77 77</u>
                                        </a>
                                    </div>
                                    <div className="textwidget">
                                        <p>
                                            Główni redaktorzy Biuletynu
                                            <br />
                                            Monika Florczak
                                            <br />
                                            Marta Kolibska
                                            <br />
                                            e-mail:{' '}
                                            <a href="mailto:bip@um.wroc.pl" role="link">
                                                bip@um.wroc.pl
                                            </a>
                                            <br />
                                            <br />
                                            <a href="https://bip.um.wroc.pl/contents/content/18/12">Zespół redakcyjny BIP </a>{' '}
                                        </p>
                                    </div>
                                </div>
                                <div className="col-12 col-xl-4">
                                    <div style={{ fontSize: '18px', fontWeight: 'bold' }} className="widgettitle">
                                        Adres redakcji Biuletynu
                                    </div>{' '}
                                    <div className="textwidget">
                                        <p>
                                            Urząd Miejski Wrocławia <br />
                                            pl. Nowy Targ 1-8,
                                            <br />
                                            50-141 Wrocław
                                            <br />
                                            pokój 041
                                            <br /> <br />
                                            <a href="http://cui.wroclaw.pl/">
                                                Obsługa informatyczna UMW: <b>CUI</b>
                                            </a>
                                            <br />
                                            <a href="https://bip.um.wroc.pl/kontakt/formularz">Formularz kontaktowy</a>
                                        </p>
                                    </div>
                                </div>
                                <div className="col-12 col-xl-4">
                                    <ul id="menu-stopka" className="menu">
                                        <li>
                                            <a target="" rel="noopener noreferrer" href="https://bip.um.wroc.pl/daneosobowe" role="link">
                                                <FontAwesomeIcon icon={faUserCircle} className="icon" />
                                                Ochrona danych osobowych
                                            </a>
                                        </li>
                                        <li>
                                            <a target="" rel="noopener noreferrer" href="https://bip.um.wroc.pl/rss" role="link">
                                                <FontAwesomeIcon icon={faRss} className="icon" />
                                                RSS
                                            </a>
                                        </li>
                                        <li>
                                            <a target="" rel="noopener noreferrer" href="https://bip.um.wroc.pl/contents/content/7/1" role="link">
                                                <FontAwesomeIcon icon={faUndo} className="icon" />
                                                Ponowne wykorzystanie
                                            </a>
                                        </li>
                                        <li>
                                            <a target="" rel="noopener noreferrer" href="https://bip.um.wroc.pl/contents/content/7/2" role="link">
                                                <FontAwesomeIcon icon={faQuestionCircle} className="icon" />
                                                Udostępnianie informacji publicznej
                                            </a>
                                        </li>
                                        <li>
                                            <a target="" rel="noopener noreferrer" href="https://bip.um.wroc.pl/statystyki" role="link">
                                                <FontAwesomeIcon icon={faChartBar} className="icon" />
                                                Statystyki oglądalności BIP
                                            </a>
                                        </li>
                                        <li>
                                            <a target="" rel="noopener noreferrer" href="https://bip.um.wroc.pl/ostatnio-opublikowane/10" role="link">
                                                <FontAwesomeIcon icon={faCalendarPlus} className="icon" />
                                                Ostatnio opublikowane
                                            </a>
                                        </li>
                                    </ul>
                                    <CookieConsent
                                        location="bottom"
                                        buttonText="Akceptuję"
                                        cookieName="myAwesomeCookieName2"
                                        style={{ background: '#2B373B' }}
                                        buttonStyle={{ color: '#110e0e', fontSize: '13px' }}
                                        expires={150}
                                    >
                                        Ta strona używa ciasteczek, by zwiększyć satysfakcję z dostarczanej usługi. <span style={{ fontSize: '13px' }}>Akceptuj, by kontynuować.</span>
                                    </CookieConsent>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div id="socket">
                        <div className="container d-flex justify-content-between">
                            <span className="float-right">© Copyright - Urząd Miejski Wrocławia</span>
                            <span className="float-right mr-3">
                                Realizacja -{' '}
                                <a href="http://www.profeko.pl/" id="author">
                                    <u>Profeko </u>
                                </a>
                                <br />
                                ver. F1.0.5/B{version}
                            </span>
                        </div>
                    </div>
                </footer>
            </footer>
        </>
    );
};

export { Footer };
